import * as products from '@appStore/products/actions/products.actions';
import * as agreements from '@appStore/products/actions/agreement.actions';

export * from '@appStore/products/actions/products.actions';
export * from '@appStore/products/actions/agreement.actions'

export const ActionTypes = { 
    ...products.ProductsActionTypes, 
    ...agreements.AgreementActionTypes
};

export type Actions = 
    products.ProductsActions | 
    agreements.AgreementActions